import axios from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Icon, Input, Segment, Select } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
import emailjs from '@emailjs/browser';

function UserLogIn() {
    /*#########################[Const]##################################*/
    const [loginD, setLoginD] = useState([])
    const [userData, setUserData] = useState({e_email : null , e_nom: null})
    const [EtudiantListe, setEtudiantListe] = useState([])
    const [groupeListe, setGroupeListe] = useState([])
    
    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        const inputIsLogged = localStorage.getItem('EtudiantData');
        if (inputIsLogged) {window.location.href = "/Etudiant/L";}
        
        axios.post(`${GConf.ApiLink}/etudiant/select-list`, {
                test : null 
        })
        .then(function (response) {
            setEtudiantListe(response.data)
        })

        

    },[]);

    /*#########################[Functions]##################################*/
    const FetchGroupeListe = (val) =>{
        let selected = EtudiantListe.filter((data) => data.e_groupe == val)
        let fl = selected.map((data, index) => ({key: data.ide, value: JSON.stringify(data), text: data.e_nom}))
        setGroupeListe(fl)
    }

     const EnvoyerEmail = () =>{
        if (!userData.e_email) {toast.error("Email invalide  !", GConf.TostErrorGonf)}
        else{

           const code = Math.floor(1000 + Math.random() * 9000);
            //this is the mail : email
            emailjs.send("service_ts0xzai","template_od9ymow",{
                passcode: code,
                time: 5 ,
                email: userData.e_email,
            },
            'nmFDIv5BV7Do6bF1u'
            ).then(() => console.log('Email sent!'))
            .catch(err => console.log('Error: ' + err));


            //update the code i DB
            axios.post(`${GConf.ApiLink}/etudiant/update-pwd`, {
                ide : userData.ide,
                e_live_pwd : code,
            }).then(function (response) {
                if(response.data.length != 0) {
                        toast.success("voir votre boite mail  !", GConf.TostSuucessGonf)
                }
                else{
                    toast.error('echeck ! ', GConf.TostSuucessGonf)
                }
            })
        } 
    }

    const logInSystem = () =>{
        if (!loginD.Pwd) {toast.error("Entrer Le code reçue !", GConf.TostErrorGonf)}
        else{
            axios.post(`${GConf.ApiLink}/etudiant/LogIn`, {
                ide : userData.ide,
                e_email : userData.e_email,
                e_live_pwd : loginD.Pwd,
            }).then(function (response) {
                if(response.data.length != 0) {
                       toast.success("Connecté !", GConf.TostSuucessGonf)
                        localStorage.setItem('EtudiantData', JSON.stringify(response.data[0]));
                        window.location.href = "/Etudiant";
                }
                else{
                    toast.error('Ce compte n\'existe pas ! ', GConf.TostSuucessGonf)
                }
            })
        } 
    }
    
    return ( <>
             <div className='container d-flex align-items-center justify-content-center' style={{paddingTop:'100px'}}>
                <div className='col-12 col-lg-5'>
                <Segment padded className='sub-sys-round' style={{borderBottom:`3px solid ${GConf.themeColor}`}}>
                            <h2 className='text-cente'><Icon name='linkify' /> Connexion des Etudiant</h2>
                            <br />
                            <div className='mb-3'>
                                <Select placeholder='Groupe ..' className='shadow-sm w-100' options={GConf.groupeListe.map((data, index) => ({id : index, value: data.grid, text:`${data.spec} - ${data.grp} ` }))} onChange={(e, { value }) => FetchGroupeListe(value)} />
                            </div>
                            <div className='mb-3'>
                                <Select placeholder='Etudiant ..' className='shadow-sm w-100' options={groupeListe} onChange={(e, { value }) => setUserData(JSON.parse(value))} />
                            </div>
                            <div className='mb-3'>
                                <Button onClick={() =>  EnvoyerEmail()}  style={{backgroundColor: "#06b8af", color:'white'}} className='shadow-sm w-100'>Envoyer  Code à  :  {userData.e_email} </Button>
                            </div>

                            <div className='mb-3'>
                                <Input  icon='key' iconPosition='left' placeholder='Code Reçue' type='password' className='shadow-sm w-100' onChange={(e) => setLoginD({...loginD, Pwd: e.target.value })}/>
                            </div>
                            <div className='mb-3'>
                                <Button onClick={logInSystem}  style={{backgroundColor:GConf.themeColor, color:'white'}} className='shadow-sm w-100'>Connextion</Button>
                            </div>
                </Segment>
                </div>
            </div>
            
    </> );
}

export default UserLogIn;